export const Types = {
  REQUEST: '@perguntas/REQUEST',
  SUCCESS: '@perguntas/SUCCESS',
  FAILURE: '@perguntas/FAILURE',
};

export function loadPerguntasRequest(statusEstabelecimento) {
  return {
    type: Types.REQUEST,
    payload: { statusEstabelecimento },
  };
}

export function loadPerguntasSuccess(perguntas) {
  return {
    type: Types.SUCCESS,
    payload: perguntas,
  };
}

export function loadPerguntasFailure() {
  return {
    type: Types.FAILURE,
  };
}
